import React from "react";
import {Link} from "gatsby";
import {isActiveMenuItem} from "../util/menu";

type UrlTarget = '_blank' | '_self';

interface MenuItemProps {
    label: string;
    title?: string;
    href: string;
    target?: UrlTarget,
    classList: string[]
}

const navItems: MenuItemProps[] = [
    {
        label: 'Home',
        href: '/',
        classList: []
    },
    {
        label: 'Rechtsanwalt',
        href: '/rechtsanwalt/',
        classList: []
    },
    {
        label: 'Rechtsgebiete',
        href: '/rechtsgebiete',
        classList: []
    },
    {
        label: 'Lesenswertes',
        href: '/lesenswertes',
        classList: []
    },
    {
        label: 'Kooperationen',
        href: '/kooperationen',
        classList: []
    },
    {
        label: 'Kontakt',
        href: '/kontakt',
        classList: []
    },
];


interface HeaderMenuProps {
    onMenuLinkChange: Function;
    menuVisible: boolean;
}

const HeaderMenu: React.FC<HeaderMenuProps> = (props: HeaderMenuProps) => {

    const onMenuLinkClick = () => {
        props.onMenuLinkChange();
    };

    return (
        <div className={'relative'}>
            <div
                className="absolute xl:relative w-full flex flex-wrap flex-col justify-around text-white uppercase xl:flex-row xl:bg-red lg:border-0 z-50">
                {navItems.map((item, i) => {
                    return (
                        <div
                            className={['menu-item', 'md:mr-0 xl:mr[75px] bg-red', 'border-t border-t-white xl:border-0 transition-opacity duration-500 opacity-0 xl:opacity-100', (props.menuVisible) ? 'opacity-100' : '', `delay-${i}00`, ...item.classList].join(' ')}
                            key={`primary-menu-item-${i}`}>
                            <Link to={item.href}
                                  title={item.title ? item.title : item.label}
                                  className={['px-8 py-4 p-1 w-full block md:px-16 lg:px-32 xl:px-[25px] text-2xl', (isActiveMenuItem(item.href)) ? 'font-bold' : ''].join(' ')}
                                  onClick={onMenuLinkClick}
                            >
                                {item.label}
                            </Link>
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default HeaderMenu;
